import axios, { encodeData } from "../utils/axios";

export const fetchApplicationReferrals = async (id) => {
  const res = await axios
    .get("/applicationReferrals/application/?id=" + id)
    .catch((error) => {
      if (error.response) {
        console.error(error);
      }
    });

  return res.data;
};

export const fetchApplicationReferralsExternalUser = async (id) => {
  const res = await axios
    .get("/applicationReferrals/application/external-user/?id=" + id)
    .catch((error) => {
      if (error.response) {
        console.error(error);
      }
    });

  return res.data;
};

export const createApplicationReferral = async (newApplicationReferral) => {
  await axios.post(
    "/applicationReferrals/create",
    encodeData(newApplicationReferral)
  );
};

export const updateApplicationReferral = async (updatedApplicationReferral) => {
  await axios.put(
    "/applicationReferrals/update",
    encodeData(updatedApplicationReferral)
  );
};

export const deleteApplicationReferral = async (oldApplicationKinds) => {
  await axios.delete("/applicationReferrals/delete", {
    data: encodeData(oldApplicationKinds),
  });
};
